class TemplateInfoCtrl {
    /** @ngInject */
    constructor(ContactTelephone) {
        this.ContactTelephone = ContactTelephone
    }
}

export default {
    template: require('./templateInfo.jade')(),
    controller: TemplateInfoCtrl,
    bindings: {},
}



// WEBPACK FOOTER //
// ./src/states/template/templateInfo.js